import { render, staticRenderFns } from "./Comprador.vue?vue&type=template&id=13155d00&scoped=true&"
import script from "./Comprador.vue?vue&type=script&lang=js&"
export * from "./Comprador.vue?vue&type=script&lang=js&"
import style0 from "./Comprador.vue?vue&type=style&index=0&id=13155d00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13155d00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VDivider,VForm,VOverlay,VProgressCircular})
